import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IAppletResourceErrorParams extends IBaseSosErrorParams {
	kind: 'appletResourcesError';
}

export default class AppletResourceError extends AppletError {
	constructor(parameters: IAppletResourceErrorParams) {
		super({
			...parameters,
			kind: 'appletError',
		});
		this.name = 'AppletResourceError';
	}
}
